import Collect from '@/views/normal/collect/index.vue'

export default [
  {
    path: '/normal/collect',
    name: 'Collect',
    component: Collect,
    meta: {
      authRequired: true,
      desc: '일반회수'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/normal/index.js